import React from 'react'
import Box from '@mui/material/Box'
import TripleCheck from '../../../../components/Switch/TripleCheck'
import Typography from '@mui/material/Typography'
import { Grid } from '@mui/material'

const VDICheckLine = ({ value, onChange, title, description }) => (
  <Grid item xs={12} lg={6}>
    <Box display="flex" alignItems="center" gap={1}>
      <TripleCheck value={value ?? null} onChange={onChange} />
      <Typography variant="title2" fontSize="1rem">
        {title}
      </Typography>
      <Typography fontStyle="italic" fontWeight="light" fontSize="0.8rem">
        {description}
      </Typography>
    </Box>
  </Grid>
)

export default VDICheckLine
